/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Ketone from './ketone';
import KetoneDetail from './ketone-detail';
import KetoneUpdate from './ketone-update';
import KetoneDeleteDialog from './ketone-delete-dialog';

const KetoneRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Ketone />} />
    <Route path="new" element={<KetoneUpdate />} />
    <Route path=":id">
      <Route index element={<KetoneDetail />} />
      <Route path="edit" element={<KetoneUpdate />} />
      <Route path="delete" element={<KetoneDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default KetoneRoutes;
